import styled from 'styled-components';

const MyDiv = styled.div`
  .checkinCard {
  background: linear-gradient(
  90deg,
  rgba(0, 104, 56, 0.05) 0%,
  rgba(0, 104, 56, 0.08) 50%,
  rgba(0, 104, 56, 0.21) 100%
);

    border-radius: 1rem;
    box-shadow: 0px 0px 44px 0px rgba(0, 0, 0, 0.06);

    // padding: 1.5rem;
    padding:10px;

  }

  .checkedinBadge {
    background-color: #fef3c7; 
    color: #1e293b;
    padding: 6px 12px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    display: inline-block;
    align-self: flex-end;
  }

  .checkedinTime {
    color: #f59e0b; 
    font-weight: 600;
  }

  .clockIcon {
    width: 24px;
    height: 24px;
  }


  .date {
   
    color: #000000;
  }

  .hoursLabel {
    
    color: #000000;
  }

  .hoursValue {
    
    color: #000000;
     text-align: right;
  }

  .check_btn {
    border-radius: 8px;
  }
`

export default MyDiv;
